/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PatchIncidentDto = {
    assignedTeamIds?: Array<string>;
    assignedUserIds?: Array<string>;
    collaborationToolItemIds?: Array<string>;
    comment?: string;
    criticality?: number;
    name?: string;
    qualification?: PatchIncidentDto.qualification;
    status?: PatchIncidentDto.status;
};

export namespace PatchIncidentDto {

    export enum qualification {
        FIXED = 'FIXED',
        FALSE_POSITIVE = 'FALSE_POSITIVE',
        NO_ACTION_NEEDED = 'NO_ACTION_NEEDED',
        DUPLICATE = 'DUPLICATE',
        AUTOMATIC = 'AUTOMATIC',
    }

    export enum status {
        OPEN = 'OPEN',
        IN_PROGRESS = 'IN_PROGRESS',
        CLOSED = 'CLOSED',
    }


}
